import { render } from "./RemoteSearchStudentInputbox.vue?vue&type=template&id=c50fe922"
import script from "./RemoteSearchStudentInputbox.vue?vue&type=script&lang=js"
export * from "./RemoteSearchStudentInputbox.vue?vue&type=script&lang=js"

import "./RemoteSearchStudentInputbox.vue?vue&type=style&index=0&id=c50fe922&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__